import { render, staticRenderFns } from "./access-secret-alert.vue?vue&type=template&id=6a3b9483&scoped=true"
import script from "./access-secret-alert.vue?vue&type=script&lang=js"
export * from "./access-secret-alert.vue?vue&type=script&lang=js"
import style0 from "./access-secret-alert.vue?vue&type=style&index=0&id=6a3b9483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b9483",
  null
  
)

export default component.exports